import { useOutletContext } from "react-router-dom";
import { OutletContextType } from "../../types/GlobalType.ts";
import { useState } from "react";

const Role: React.FC = () => {
  const { isDarkMode } = useOutletContext<OutletContextType>();

  const [isNewRoleModalOpen, setIsNewRoleModalOpen] = useState(false);

  const [newRoleForm, setNewRoleForm] = useState({
    name: "",
    description: "",
    permissions: {
      dashboard: false,
      students: false,
      teachers: false,
      attendance: false,
      payments: false,
      communications: false,
      events: false,
      settings: false,
    },
  });

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Gestion des rôles</h2>
      <p className={`mb-6 ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
        Configurez les rôles et les permissions des utilisateurs
      </p>
      <div className="mb-6 flex justify-between items-center">
        <div className="relative w-64">
          <div
            className={`absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500`}
          >
            <i className="fas fa-search"></i>
          </div>
          <input
            type="text"
            placeholder="Rechercher un rôle..."
            className={`w-full pl-10 pr-4 py-2 rounded-md text-sm ${
              isDarkMode
                ? "bg-[#161B22] border-gray-700"
                : "bg-white border-gray-300"
            } border focus:outline-none focus:ring-2 focus:ring-blue-500`}
          />
        </div>
        <button
          onClick={() => setIsNewRoleModalOpen(true)}
          className={`flex items-center px-4 py-2 rounded-md ${
            isDarkMode
              ? "bg-blue-600 hover:bg-blue-700"
              : "bg-blue-500 hover:bg-blue-600"
          } text-white !rounded-button whitespace-nowrap`}
        >
          <i className="fas fa-plus-circle mr-2"></i>
          <span>Nouveau rôle</span>
        </button>
        {isNewRoleModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div
              className={`${
                isDarkMode ? "bg-[#161B22]" : "bg-white"
              } rounded-lg p-6 w-full max-w-lg`}
            >
              <h3 className="text-xl font-semibold mb-4">
                Créer un nouveau rôle
              </h3>
              <div className="space-y-4">
                <div>
                  <label
                    className={`block text-sm font-medium mb-1 ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Nom du rôle
                  </label>
                  <input
                    type="text"
                    value={newRoleForm.name}
                    onChange={(e) =>
                      setNewRoleForm({
                        ...newRoleForm,
                        name: e.target.value,
                      })
                    }
                    className={`w-full px-3 py-2 rounded-md border ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700 text-white"
                        : "bg-white border-gray-300"
                    } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    placeholder="Ex: Responsable pédagogique"
                  />
                </div>
                <div>
                  <label
                    className={`block text-sm font-medium mb-1 ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Description
                  </label>
                  <textarea
                    value={newRoleForm.description}
                    onChange={(e) =>
                      setNewRoleForm({
                        ...newRoleForm,
                        description: e.target.value,
                      })
                    }
                    className={`w-full px-3 py-2 rounded-md border ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700 text-white"
                        : "bg-white border-gray-300"
                    } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    rows={3}
                    placeholder="Description des responsabilités et accès"
                  />
                </div>
                <div>
                  <label
                    className={`block text-sm font-medium mb-2 ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Permissions
                  </label>
                  <div className="space-y-2">
                    {Object.entries(newRoleForm.permissions).map(
                      ([key, value]) => (
                        <label key={key} className="flex items-center">
                          <input
                            type="checkbox"
                            checked={value}
                            onChange={(e) =>
                              setNewRoleForm({
                                ...newRoleForm,
                                permissions: {
                                  ...newRoleForm.permissions,
                                  [key]: e.target.checked,
                                },
                              })
                            }
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                          />
                          <span className="ml-2 capitalize">
                            {key === "dashboard"
                              ? "Tableau de bord"
                              : key === "students"
                                ? "Gestion des élèves"
                                : key === "teachers"
                                  ? "Gestion des enseignants"
                                  : key === "attendance"
                                    ? "Gestion des présences"
                                    : key === "payments"
                                      ? "Gestion des paiements"
                                      : key === "communications"
                                        ? "Communications"
                                        : key === "events"
                                          ? "Événements"
                                          : "Paramètres"}
                          </span>
                        </label>
                      ),
                    )}
                  </div>
                </div>
              </div>
              <div className="mt-6 flex justify-end space-x-3">
                <button
                  onClick={() => {
                    setIsNewRoleModalOpen(false);
                    setNewRoleForm({
                      name: "",
                      description: "",
                      permissions: {
                        dashboard: false,
                        students: false,
                        teachers: false,
                        attendance: false,
                        payments: false,
                        communications: false,
                        events: false,
                        settings: false,
                      },
                    });
                  }}
                  className={`px-4 py-2 rounded-md ${
                    isDarkMode
                      ? "bg-gray-700 hover:bg-gray-600"
                      : "bg-gray-200 hover:bg-gray-300"
                  } !rounded-button whitespace-nowrap`}
                >
                  Annuler
                </button>
                <button
                  onClick={() => {
                    // Here you would typically make an API call to save the new role
                    // console.log("New role:", newRoleForm);
                    setIsNewRoleModalOpen(false);
                    setNewRoleForm({
                      name: "",
                      description: "",
                      permissions: {
                        dashboard: false,
                        students: false,
                        teachers: false,
                        attendance: false,
                        payments: false,
                        communications: false,
                        events: false,
                        settings: false,
                      },
                    });
                  }}
                  className={`px-4 py-2 rounded-md ${
                    isDarkMode
                      ? "bg-blue-600 hover:bg-blue-700"
                      : "bg-blue-500 hover:bg-blue-600"
                  } text-white !rounded-button whitespace-nowrap`}
                >
                  Créer
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div
        className={`rounded-lg overflow-hidden border ${
          isDarkMode ? "border-gray-700" : "border-gray-300"
        } mb-6`}
      >
        <table className="min-w-full divide-y divide-gray-700">
          <thead className={`${isDarkMode ? "bg-[#161B22]" : "bg-gray-50"}`}>
            <tr>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
              >
                Rôle
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
              >
                Description
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
              >
                Utilisateurs
              </th>
              {/* <th
                scope="col"
                className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
              >
                Actions
              </th> */}
            </tr>
          </thead>
          <tbody
            className={`${isDarkMode ? "bg-[#0D1117]" : "bg-white"} divide-y ${
              isDarkMode ? "divide-gray-700" : "divide-gray-200"
            }`}
          >
            <tr
              className={`${
                isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
              }`}
            >
              <td className="px-6 py-4 whitespace-nowrap">
                <span
                  className={`font-medium ${
                    isDarkMode ? "text-gray-200" : "text-gray-700"
                  }`}
                >
                  Administrateur
                </span>
              </td>
              <td className="px-6 py-4">
                <div
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-500"
                  }`}
                >
                  Accès complet à toutes les fonctionnalités et paramètres du
                  système
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800">
                  2 utilisateurs
                </span>
              </td>
              {/* <td className="px-6 py-4 whitespace-nowrap text-center">
                <div className="flex justify-center space-x-3">
                  <button className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap">
                    <i className="fas fa-edit"></i>
                  </button>
                  <button className="text-red-500 hover:text-red-700 cursor-pointer !rounded-button whitespace-nowrap">
                    <i className="fas fa-trash-alt"></i>
                  </button>
                  {isDeleteModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                      <div
                        className={`${
                          isDarkMode ? "bg-[#161B22]" : "bg-white"
                        } rounded-lg p-6 w-full max-w-md`}
                      >
                        <div className="flex items-center mb-4">
                          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                            <i className="fas fa-exclamation-triangle text-red-500 text-xl"></i>
                          </div>
                          <h3 className="text-xl font-semibold ml-4">
                            Confirmer la suppression
                          </h3>
                        </div>
                        <p
                          className={`mb-6 ${
                            isDarkMode ? "text-gray-400" : "text-gray-600"
                          }`}
                        >
                          Êtes-vous sûr de vouloir supprimer cet élément ? Cette
                          action est irréversible et toutes les données
                          associées seront définitivement perdues.
                        </p>
                        <div className="mb-4">
                          <label className="flex items-center">
                            <input
                              type="checkbox"
                              checked={deleteConfirmed}
                              onChange={(e) =>
                                setDeleteConfirmed(e.target.checked)
                              }
                              className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                            />
                            <span className="ml-2 text-sm">
                              Je comprends que cette action est irréversible
                            </span>
                          </label>
                        </div>
                        <div className="flex justify-end space-x-3">
                          <button
                            onClick={() => {
                              setIsDeleteModalOpen(false);
                              setItemToDelete(null);
                              setDeleteConfirmed(false);
                            }}
                            className={`px-4 py-2 rounded-md ${
                              isDarkMode
                                ? "bg-gray-700 hover:bg-gray-600"
                                : "bg-gray-200 hover:bg-gray-300"
                            } !rounded-button whitespace-nowrap`}
                          >
                            Annuler
                          </button>
                          <button
                            disabled={!deleteConfirmed}
                            className={`px-4 py-2 rounded-md ${
                              deleteConfirmed
                                ? "bg-red-600 hover:bg-red-700"
                                : "bg-red-300 cursor-not-allowed"
                            } text-white !rounded-button whitespace-nowrap`}
                          >
                            Supprimer
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </td> */}
            </tr>
            <tr
              className={`${
                isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
              }`}
            >
              <td className="px-6 py-4 whitespace-nowrap">
                <span
                  className={`font-medium ${
                    isDarkMode ? "text-gray-200" : "text-gray-700"
                  }`}
                >
                  Enseignant
                </span>{" "}
              </td>
              <td className="px-6 py-4">
                <div
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-500"
                  }`}
                >
                  Gestion des classes, des élèves et des notes
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 py-1 text-xs font-medium rounded-full bg-purple-100 text-purple-800">
                  15 utilisateurs
                </span>
              </td>
              {/* <td className="px-6 py-4 whitespace-nowrap text-center">
                <div className="flex justify-center space-x-3">
                  <button className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap">
                    <i className="fas fa-edit"></i>
                  </button>
                  <button className="text-red-500 hover:text-red-700 cursor-pointer !rounded-button whitespace-nowrap">
                    <i className="fas fa-trash-alt"></i>
                  </button>
                  {isDeleteModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                      <div
                        className={`${
                          isDarkMode ? "bg-[#161B22]" : "bg-white"
                        } rounded-lg p-6 w-full max-w-md`}
                      >
                        <div className="flex items-center mb-4">
                          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                            <i className="fas fa-exclamation-triangle text-red-500 text-xl"></i>
                          </div>
                          <h3 className="text-xl font-semibold ml-4">
                            Confirmer la suppression
                          </h3>
                        </div>
                        <p
                          className={`mb-6 ${
                            isDarkMode ? "text-gray-400" : "text-gray-600"
                          }`}
                        >
                          Êtes-vous sûr de vouloir supprimer cet élément ? Cette
                          action est irréversible et toutes les données
                          associées seront définitivement perdues.
                        </p>
                        <div className="mb-4">
                          <label className="flex items-center">
                            <input
                              type="checkbox"
                              checked={deleteConfirmed}
                              onChange={(e) =>
                                setDeleteConfirmed(e.target.checked)
                              }
                              className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                            />
                            <span className="ml-2 text-sm">
                              Je comprends que cette action est irréversible
                            </span>
                          </label>
                        </div>
                        <div className="flex justify-end space-x-3">
                          <button
                            onClick={() => {
                              setIsDeleteModalOpen(false);
                              setItemToDelete(null);
                              setDeleteConfirmed(false);
                            }}
                            className={`px-4 py-2 rounded-md ${
                              isDarkMode
                                ? "bg-gray-700 hover:bg-gray-600"
                                : "bg-gray-200 hover:bg-gray-300"
                            } !rounded-button whitespace-nowrap`}
                          >
                            Annuler
                          </button>
                          <button
                            disabled={!deleteConfirmed}
                            className={`px-4 py-2 rounded-md ${
                              deleteConfirmed
                                ? "bg-red-600 hover:bg-red-700"
                                : "bg-red-300 cursor-not-allowed"
                            } text-white !rounded-button whitespace-nowrap`}
                          >
                            Supprimer
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </td> */}
            </tr>
            {/* <tr
              className={`${
                isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
              }`}
            >
              <td className="px-6 py-4 whitespace-nowrap">
                <span
                  className={`font-medium ${
                    isDarkMode ? "text-gray-200" : "text-gray-700"
                  }`}
                >
                  Parent
                </span>{" "}
              </td>
              <td className="px-6 py-4">
                <div
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-500"
                  }`}
                >
                  Consultation des informations de leurs enfants, paiements
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 py-1 text-xs font-medium rounded-full bg-yellow-100 text-yellow-800">
                  187 utilisateurs
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-center">
                <div className="flex justify-center space-x-3">
                  <button className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap">
                    <i className="fas fa-edit"></i>
                  </button>
                  <button className="text-red-500 hover:text-red-700 cursor-pointer !rounded-button whitespace-nowrap">
                    <i className="fas fa-trash-alt"></i>
                  </button>
                  {isDeleteModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                      <div
                        className={`${
                          isDarkMode ? "bg-[#161B22]" : "bg-white"
                        } rounded-lg p-6 w-full max-w-md`}
                      >
                        <div className="flex items-center mb-4">
                          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                            <i className="fas fa-exclamation-triangle text-red-500 text-xl"></i>
                          </div>
                          <h3 className="text-xl font-semibold ml-4">
                            Confirmer la suppression
                          </h3>
                        </div>
                        <p
                          className={`mb-6 ${
                            isDarkMode ? "text-gray-400" : "text-gray-600"
                          }`}
                        >
                          Êtes-vous sûr de vouloir supprimer cet élément ? Cette
                          action est irréversible et toutes les données
                          associées seront définitivement perdues.
                        </p>
                        <div className="mb-4">
                          <label className="flex items-center">
                            <input
                              type="checkbox"
                              checked={deleteConfirmed}
                              onChange={(e) =>
                                setDeleteConfirmed(e.target.checked)
                              }
                              className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                            />
                            <span className="ml-2 text-sm">
                              Je comprends que cette action est irréversible
                            </span>
                          </label>
                        </div>
                        <div className="flex justify-end space-x-3">
                          <button
                            onClick={() => {
                              setIsDeleteModalOpen(false);
                              setItemToDelete(null);
                              setDeleteConfirmed(false);
                            }}
                            className={`px-4 py-2 rounded-md ${
                              isDarkMode
                                ? "bg-gray-700 hover:bg-gray-600"
                                : "bg-gray-200 hover:bg-gray-300"
                            } !rounded-button whitespace-nowrap`}
                          >
                            Annuler
                          </button>
                          <button
                            disabled={!deleteConfirmed}
                            className={`px-4 py-2 rounded-md ${
                              deleteConfirmed
                                ? "bg-red-600 hover:bg-red-700"
                                : "bg-red-300 cursor-not-allowed"
                            } text-white !rounded-button whitespace-nowrap`}
                          >
                            Supprimer
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </td>
            </tr> */}
            <tr
              className={`${
                isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
              }`}
            >
              <td className="px-6 py-4 whitespace-nowrap">
                <span
                  className={`font-medium ${
                    isDarkMode ? "text-gray-200" : "text-gray-700"
                  }`}
                >
                  Comptable
                </span>{" "}
              </td>
              <td className="px-6 py-4">
                <div
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-500"
                  }`}
                >
                  Gestion des paiements et des finances
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 py-1 text-xs font-medium rounded-full bg-indigo-100 text-indigo-800">
                  3 utilisateurs
                </span>
              </td>
              {/* <td className="px-6 py-4 whitespace-nowrap text-center">
                <div className="flex justify-center space-x-3">
                  <button className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap">
                    <i className="fas fa-edit"></i>
                  </button>
                  <button className="text-red-500 hover:text-red-700 cursor-pointer !rounded-button whitespace-nowrap">
                    <i className="fas fa-trash-alt"></i>
                  </button>
                  {isDeleteModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                      <div
                        className={`${
                          isDarkMode ? "bg-[#161B22]" : "bg-white"
                        } rounded-lg p-6 w-full max-w-md`}
                      >
                        <div className="flex items-center mb-4">
                          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                            <i className="fas fa-exclamation-triangle text-red-500 text-xl"></i>
                          </div>
                          <h3 className="text-xl font-semibold ml-4">
                            Confirmer la suppression
                          </h3>
                        </div>
                        <p
                          className={`mb-6 ${
                            isDarkMode ? "text-gray-400" : "text-gray-600"
                          }`}
                        >
                          Êtes-vous sûr de vouloir supprimer cet élément ? Cette
                          action est irréversible et toutes les données
                          associées seront définitivement perdues.
                        </p>
                        <div className="mb-4">
                          <label className="flex items-center">
                            <input
                              type="checkbox"
                              checked={deleteConfirmed}
                              onChange={(e) =>
                                setDeleteConfirmed(e.target.checked)
                              }
                              className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                            />
                            <span className="ml-2 text-sm">
                              Je comprends que cette action est irréversible
                            </span>
                          </label>
                        </div>
                        <div className="flex justify-end space-x-3">
                          <button
                            onClick={() => {
                              setIsDeleteModalOpen(false);
                              setItemToDelete(null);
                              setDeleteConfirmed(false);
                            }}
                            className={`px-4 py-2 rounded-md ${
                              isDarkMode
                                ? "bg-gray-700 hover:bg-gray-600"
                                : "bg-gray-200 hover:bg-gray-300"
                            } !rounded-button whitespace-nowrap`}
                          >
                            Annuler
                          </button>
                          <button
                            className={`px-4 py-2 rounded-md ${
                              deleteConfirmed
                                ? "bg-red-600 hover:bg-red-700"
                                : "bg-red-300 cursor-not-allowed"
                            } text-white !rounded-button whitespace-nowrap`}
                          >
                            Supprimer
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </td> */}
            </tr>
          </tbody>
        </table>
      </div>
      <div
        className={`p-4 rounded-lg border ${
          isDarkMode
            ? "bg-[#0D1117] border-gray-700"
            : "bg-gray-50 border-gray-200"
        }`}
      >
        <h3 className="text-lg font-medium mb-4">Matrice des permissions</h3>
        <div
          className={`overflow-x-auto ${
            isDarkMode ? "bg-[#161B22]" : "bg-white"
          } rounded-lg border ${
            isDarkMode ? "border-gray-700" : "border-gray-300"
          }`}
        >
          <table className="min-w-full divide-y divide-gray-700">
            <thead className={`${isDarkMode ? "bg-[#0D1117]" : "bg-gray-50"}`}>
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                >
                  Module / Fonctionnalité
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                >
                  <div>Administrateur</div>
                  <div className="text-xs font-normal  text-gray-500 mt-1">
                    L / E
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                >
                  <div>Enseignant</div>
                  <div className="text-xs font-normal  text-gray-500 mt-1">
                    L / E
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                >
                  <div>Parent</div>
                  <div className="text-xs font-normal  text-gray-500 mt-1">
                    L / E
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                >
                  <div>Comptable</div>
                  <div className="text-xs font-normal  text-gray-500 mt-1">
                    L / E
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-700">
              <tr>
                <td className="px-6 py-4 whitespace-nowrap font-medium">
                  <span
                    className={`font-medium ${
                      isDarkMode ? "text-gray-200" : "text-gray-700"
                    }`}
                  >
                    Tableau de bord
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap font-medium">
                  <span
                    className={`font-medium ${
                      isDarkMode ? "text-gray-200" : "text-gray-700"
                    }`}
                  >
                    Gestion des élèves
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap font-medium">
                  <span
                    className={`font-medium ${
                      isDarkMode ? "text-gray-200" : "text-gray-700"
                    }`}
                  >
                    Gestion des enseignants
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap font-medium">
                  <span
                    className={`font-medium ${
                      isDarkMode ? "text-gray-200" : "text-gray-700"
                    }`}
                  >
                    Gestion des présences
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap font-medium">
                  <span
                    className={`font-medium ${
                      isDarkMode ? "text-gray-200" : "text-gray-700"
                    }`}
                  >
                    Gestion des paiements
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap font-medium">
                  <span
                    className={`font-medium ${
                      isDarkMode ? "text-gray-200" : "text-gray-700"
                    }`}
                  >
                    Communications
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap font-medium">
                  <span
                    className={`font-medium ${
                      isDarkMode ? "text-gray-200" : "text-gray-700"
                    }`}
                  >
                    Événements
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap font-medium">
                  <span
                    className={`font-medium ${
                      isDarkMode ? "text-gray-200" : "text-gray-700"
                    }`}
                  >
                    Paramètres
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      defaultChecked
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex justify-center space-x-2">
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      title="Lecture"
                    />
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      title="Écriture"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-6 flex justify-end space-x-3">
        <button
          className={`px-4 py-2 rounded-md ${
            isDarkMode
              ? "bg-gray-700 hover:bg-gray-600"
              : "bg-gray-200 hover:bg-gray-300"
          } !rounded-button whitespace-nowrap`}
        >
          Annuler
        </button>
        <button
          className={`px-4 py-2 rounded-md ${
            isDarkMode
              ? "bg-blue-600 hover:bg-blue-700"
              : "bg-blue-500 hover:bg-blue-600"
          } text-white !rounded-button whitespace-nowrap`}
        >
          Enregistrer les modifications
        </button>
      </div>
    </div>
  );
};

export default Role;
